import React from 'react';
import img1 from '../Components/Images/About/about1.png'
import './Aboutcompany.css'
// Make sure you have the Bootstrap icons library installed
// npm install bootstrap-icons
// Or use the CDN in your index.html
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.0/font/bootstrap-icons.css">

const AboutCompany = () => {
  // Sample features - you can customize these
  const features = [
    {
      icon: "bi-award",
      title: "Quality Assurance",
      description: "Highest standards in all solutions"
    },
    {
      icon: "bi-people",
      title: "Expert Team",
      description: "Dedicated specialists at your service"
    },
    {
      icon: "bi-clock",
      title: "Responsive Support",
      description: "Quick assistance when you need it"
    }
  ];

  return (
    <section className="py-5 bg-light">
      <div className="container py-lg-5">
        {/* Top Label */}
        <div className="text-center mb-5">
          <span className="badge bg-primary rounded-pill px-3 py-2 mb-3">About Us</span>
          <h2 className=" fw-bold mb-4">Innovating Retail Efficiency & Industrial Productivity</h2>
          <div className="d-flex justify-content-center">
            <div className="border-bottom border-primary border-3 w-25 mb-4"></div>
          </div>
        </div>

        {/* Main Content Section */}
        <div className="row align-items-center g-5 my-4">
          {/* Image with overlay effect */}
          <div className="col-lg-6 position-relative">
            {/* <div className="position-absolute" style={{ top: '-15px', left: '-15px', width: '100%', height: '100%', border: '2px solid #0d6efd', borderRadius: '8px' }}></div> */}
            <div className="position-relative overflow-hidden rounded shadow-lg">
              {/* Use your image path here */}
              <img 
                src={img1} 
                alt="Zartec Solutions Team" 
                className="img-fluid w-100"
                style={{ transition: 'transform 0.5s ease', objectFit: 'cover' }}
                onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              />
            </div>
          </div>

          {/* Content */}
          <div className="col-lg-6">
            <h4 className="fs-4 fw-bold mb-1 text-dark">Smart Solutions for Modern Business Challenges</h4>
            
            <p className="text-muted mb-4 lh-base" style={{fontFamily:"Poppins", fontSize:"14px"}}>
              At Zartec Solutions, we lead the way in delivering cutting-edge, scalable, and dependable technologies that empower businesses across a wide range of industries. Our comprehensive suite of retail solutions includes EAS Anti-Theft Systems, RFID, Checkout Scanners, POS Terminals, Checkout Weighing & AI Scales, along with custom retail accessories tailored to meet each client’s unique needs.

            </p>
            
            <p className="text-muted mb-4 lh-base" style={{fontFamily:"Poppins", fontSize:"14px"}}>
              We proudly support core Retail sectors such as Hypermarkets, Supermarkets, and Retail Fashion , while our Industrial Manufacturing division provides high-performance solutions including Marking & Coding Equipment, Packaging Machines, and a broad array of technologies that boost productivity, accuracy, and security.

            </p>

            {/* Feature highlights */}
            <div className="row g-4 mb-5">
              {features.map((feature, index) => (
                <div key={index} className="col-md-4">
                  <div className="card h-100 border-0 bg-white text-center p-3 shadow-sm hover-shadow">
                    <div className="card-body">
                      <i className={`bi ${feature.icon} fs-2 text-primary mb-3`}></i>
                      <h6 className="card-title fw-bold">{feature.title}</h6>
                      <p className="card-text text-muted small" style={{fontFamily:"Poppins"}}>{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Buttons */}
            <div className="d-flex flex-wrap gap-3">
              <a href="about.html" className="btn btn-primary btn-lg button-about">
                Read More 
                <i className="bi bi-arrow-right ms-2"></i>
              </a>
              <a href="services.html" className="btn btn-outline-primary btn-lg">
                Our Services
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCompany;